let formatter: { format(n: number): string };
try {
  formatter = new Intl.NumberFormat();
} catch {
  formatter = { format: (n: number) => `${n}` };
}

export function formatAmount(amount: number): string {
  if (amount === 0) {
    return '-';
  }
  return formatter.format(amount);
}
